import * as qualityAssuranceApi from '../../api/qualityAssuranceApi'

const state = {
      QARecordInput: {},
      List: [],
      QARecordDetailOutput:{},
      QARecordID:Number,
      AfterSaleInput:{},
      AfterSaleOutput:{},
      HasMore: true,
      PageIndex:0,
      IsSelfSupport:false,
			ShowStoreSellEntry:false
}

const getters = {

}

const actions = {
	async qualityAssuranceList({commit}, QARecordInput) {
      const response = await qualityAssuranceApi.qualityAssuranceList(QARecordInput);
      if (response.Status) {
        if (response.PageNo >= response.PageCount) {
          commit('setHasMore', false)
        } else {
          commit('setHasMore', true)    
        }
        if(QARecordInput.PageNo === 1){
          commit('emptyState')
        }
        commit('setPageIndex', response.PageNo + 1)
        commit('qualityAssuranceList', response);
      }else {
        commit('setHasMore', false)
      }
      return response
    
  },
  async qualityAssuranceResult({commit}, QARecordInput) {
      const response = await qualityAssuranceApi.qualityAssuranceResult(QARecordInput);
      if (response.Status) {
        if (response.PageNo >= response.PageCount) {
          commit('setHasMore', false)
        } else {
          commit('setHasMore', true)
        }
        if(QARecordInput.PageNo===1){
          commit('emptyState')
        }
        commit('setPageIndex', response.PageNo + 1)
        commit('qualityAssuranceResult', response);
      }else {
        commit('setHasMore', false)
      }
      return response
  },
  async qualityAssuranceDetail({commit}, QARecordID) {
		const response = await qualityAssuranceApi.qualityAssuranceDetail(QARecordID);
		commit('qualityAssuranceRecordDetail', response);
  },
  //提交售后
  async handleAfterSales({commit}, AfterSaleInput) {
		const response = await qualityAssuranceApi.handleAfterSales(AfterSaleInput);
    commit('handleAfterSalesAssurance', response);
    return response;
  }, 
  //取消售后
  async cancelAfterSales({commit}, AfterSaleInput) {
		const response = await qualityAssuranceApi.cancelAfterSale(AfterSaleInput);
    commit('cancelAfterSalesAssurance', response);
  },
  //是否自营商家
  async isSelfSupport({commit}) {
		const response = await qualityAssuranceApi.isSelfSupport();
    commit('isSelfSupport', response);
    return response
  },
	//是否显示门店出货下单入口
	async showStoreSellEntry({commit}) {
		const response = await qualityAssuranceApi.showStoreSellEntry();
		commit('showStoreSellEntry', response);
		return response
	},
  EmptyState({commit}){
    commit('emptyState')
  }
}

const mutations = {
	qualityAssuranceList(state, data)
	{
        state.List = state.List.concat(data.Rows)
  },
  qualityAssuranceResult(state, data)
	{
        state.List = state.List.concat(data.Rows)
  },
  qualityAssuranceRecordDetail(state, data)
	{
        state.QARecordDetailOutput = data
  },
  handleAfterSalesAssurance(state, data)  //提交售后
	{
        state.AfterSaleOutput = data
  },
  cancelAfterSalesAssurance(state, data) //取消售后
	{
        state.AfterSaleOutput = data
  },
  setHasMore(state, hasMore) {
    state.HasMore = hasMore
  },
  setPageIndex(state, pageIndex) {
    //state.PageIndex = pageIndex
    state.QARecordInput.PageNo = pageIndex
  },
  isSelfSupport(state,data){
    state.IsSelfSupport=data.Data
  },
	showStoreSellEntry(state,data){
		state.ShowStoreSellEntry = data.Data
	},
  emptyState(state){
    state.List = [];
    state.HasMore = true;
    state.PageIndex = 0;
  }
}

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
  }



// WEBPACK FOOTER //
// ./src/store/modules/qualityAssuranceList.js